import React from 'react';
import '../styles/index.css';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Panorama from '../components/Panorama';
import ScrollArrow from '../components/ScrollArrow';
import About from '../components/About';
import Services from '../components/Services';
import Contact from '../components/Contact';
import Colaboration from '../components/Colaboration';
import Projects from "../components/Projects"
import { LanguageProvider } from '../context/LanguageContext';

function App() {
  return (
    <div className='App'>
      <LanguageProvider>
            <Header/>
            <Panorama/>
            <ScrollArrow/>
            <About/>
            <Services/>
            <Projects />
            {/* <Contact/> */}
            {/* <Colaboration/> */}
            <Footer/>
        </LanguageProvider>
    </div>

  );
}

export default App;
